import { ApiService } from "../apiService";

export class UsersService extends ApiService {
    constructor() {
        super();

        this.path = '/Users';
    }

    getUsers() {
        return this.get(this.path);
    }

    createUser(newUser) {
        return this.post(this.path, newUser);
    }

    updateUser(user) {
        return this.put(this.path, user);
    }

    deleteUser(id) {
        return this.delete(this.path, id);
    }

    undoUser(idUser) {
        return this.postUndo(this.path + "/undoDeleteUser", idUser);
    }
}